import React from 'react';
import { designConstants } from '../styles';
import { Icon, SimpleCollapsible, Text, TouchableNative } from './index';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { trackButtonPress } from '../../shared/utilities/gatracker';
import setTestID from '../../shared/utilities/setTestID';
import { withTheme } from '../styles/useThemeContext';

class SquareCheckButton extends React.Component {
  onPress = () => {
    trackButtonPress('CheckButton ' + (this.props.tag || this.props.text));
    this.props.onPress();
  };

  render() {
    const { colors } = this.props.theme;
    return (
      <View
        style={[
          styles.defaultItemWrapper,
          {
            borderColor: colors.buttonBlue,
          },
          this.props.style,
          this.props.checked && {
            backgroundColor: colors.buttonBlue,
          },
        ]}
      >
        <TouchableNative
          onPress={this.onPress}
          style={styles.childWrapper}
          {...setTestID(this.props.tag || this.props.text)}
        >
          {this.props.checkbox && (
            <View
              style={{
                marginHorizontal: 18,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {this.props.checked && (
                <View
                  style={{
                    position: 'absolute',
                    left: 3,
                    zIndex: -1,
                    right: 3,
                    top: 4,
                    bottom: 3,
                    backgroundColor: colors.white,
                  }}
                />
              )}
              <Icon
                name={
                  this.props.checked ? 'checkbox-outline' : 'square-outline'
                }
                type={'Ionicons'}
                style={{
                  zIndex: 0,
                  color: this.props.checked
                    ? colors.buttonBlue
                    : colors.textSecondary,
                }}
                size={22}
              />
            </View>
          )}
          <Text d white={this.props.checked} numberOfLines={1}>
            {this.props.label}
          </Text>
        </TouchableNative>
        <SimpleCollapsible collapsed={!this.props.checked}>
          {this.props.children}
        </SimpleCollapsible>
      </View>
    );
  }
}

SquareCheckButton.propTypes = {
  checkbox: PropTypes.bool,
  checked: PropTypes.bool,
  label: PropTypes.string,
};

const styles = StyleSheet.create({
  defaultItemWrapper: {
    minHeight: 48,
    marginBottom: 5,
    borderWidth: 1,
    borderRadius: 5,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  childWrapper: {
    paddingVertical: 8,
    paddingRight: 12,
    alignItems: 'center',
    flexDirection: 'row',
    height: 48,
  },
});

export default withTheme(SquareCheckButton);
